<template>
  <div>
    <div class="df">
      <p>{{titleP}}</p>
      <el-autocomplete
        v-model="cityVlaue"
        size="medium"
        ref="cityInput"
        :fetch-suggestions="querySearch"
        placeholder="中文/拼音/三字码"
        :trigger-on-focus="false"
        @select="getstarCity"
        @focus="cityListOpen('initial')"
        @blur="clearCity"
      >
        <template slot-scope="{ item }">
          <div class="name">{{ item.name }} ({{item.code}})</div>
        </template>
      </el-autocomplete>
      <!-- 字母城市 -->
      <div
        class="cityList"
        v-if="listShow"
        @mouseenter="cityListStatu = true"
        @mouseleave="cityListStatu=false"
      >
        <h6>支持中文/拼音/三字码/简拼</h6>
        <div class="cityList-head df">
          <span
            v-for="(item, index) in cityListH"
            :key="index"
            :class="{'active': cityListHShow === index}"
            @click.stop="cityListHShow = index"
          >{{item}}</span>
        </div>
        <div class="cityList-c scrollbar">
          <div v-if="cityListHShow === 0 " class="hotCity">
            <div class="HotCity">
              <span
                v-for="(item,index) in HotCity"
                :key="index"
                @click="getClickCity(item)"
              >{{item.name}}</span>
            </div>
          </div>
          <div v-else class="AZCity">
            <div v-for="(item,keys,cityIndex) in cityList" :key="cityIndex">
              <div class="AZCityList df" v-if="showCityList(item,keys,cityListHShow)!==-1">
                <div>
                  <p>{{keys}}</p>
                </div>
                <div>
                  <span
                    v-for="(items,indexs) in item"
                    :key="indexs"
                    @click="getClickCity(items)"
                  >{{items.name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const citys = require(`@/lib/data-service/flight/flight_domestic_citys`);
const _ = require(`underscore`);

export default {
  data() {
    return {
      cityVlaue: null,
      cityId: null,
      listShow: false,
      cityListH: ["热门", "ABCD", "EFGH", "JKLM", "NOPQRS", "TUVWX", "YZ"], // 热门列表
      cityListHShow: 0,
      cityList: [],
      restaurants: "",
      cityListStatu: false,
      HotCity: []
    };
  },
  props: {
    titleP: {
      type: String,
      default: "出发城市"
    }
  },
  watch: {
    cityVlaue(val) {
      !val
        ? ((this.listShow = true), this.$refs.cityInput.focus())
        : this.querySearch();
    }
  },
  methods: {
    querySearch(queryString, cb) {
      if (!queryString) return;
      this.listShow = false;
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      results.length === 0 ? (this.cityVlaue = "") : "";
      cb(results);
    },
    createFilter(queryString) {
      let pattern2 = new RegExp("[A-Za-z]+");
      if (pattern2.test(queryString)) {
        return restaurant => {
          if (restaurant.spell && restaurant.code) {
            if (
              restaurant.spell
                .toUpperCase()
                .indexOf(queryString.toUpperCase()) != -1
            ) {
              return restaurant;
            } else if (
              restaurant.code.indexOf(queryString.toUpperCase()) != -1
            ) {
              return restaurant;
            }
          } else {
            return "";
          }
        };
      } else {
        return restaurant => {
          if (restaurant.cityName.indexOf(queryString) !== -1) {
            return restaurant;
          } else {
            return "";
          }
        };
      }
    },
    getstarCity(item) {
      this.cityId = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.cityVlaue = item.name + "(" + item.code + ")";
    },
    getClickCity(item) {
      this.cityId = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.cityVlaue = item.name + "(" + item.code + ")";
      this.listShow = false;
    },
    showCityList(item, key, index) {
      if (index < this.cityListH.length) {
        return this.cityListH[index].indexOf(key);
      }
    },
    cityListOpen(init) {
      init && !this.listShow ? (this.listShow = true) : (this.listShow = false);
    },
    clearCity() {
      if (!this.cityListStatu) {
        this.listShow = false;
      }
    },
    // 获取城市接口
    loadAllCity() {
      citys().then(res => {
        this.restaurants = [...res.citys];
        let cityList = [];
        for (let i = 0; i < res.citys.length; i++) {
          if (res.citys[i].airports === false) {
            cityList.push(res.citys[i]);
          }
          if (
            res.citys[i].isHot === "Y" &&
            this.HotCity.length < 23 &&
            res.citys[i].airports === false
          ) {
            this.HotCity.push(res.citys[i]);
          }
        }
        this.cityList = _.chain(cityList)
          .groupBy(function(m) {
            return m.initial;
          })
          .value();
      });
    }
  },
  created() {
    this.loadAllCity();
  },
  destroyed() {}
};
</script>
<style lang='less' scoped>
@import "./css/index.less";
</style>